import {Point} from '../types';
import {getScaleDir} from './scaleUtils';
import {NORMALIZED_VALUES_FIXED} from '../const';
import {useCallback} from 'react';

type normalizePointType = {
  point: Point;
  width: number;
  height: number;
  imageLayer: any;
  imageWidth: number;
  imageHeight: number;
};

export function normalizePoint({
  point,
  width,
  height,
  imageLayer,
  imageWidth,
  imageHeight,
}: normalizePointType): Point {
  const xOffset = ((imageWidth - width) / 2) * getScaleDir(width, imageWidth);
  const yOffset = ((imageHeight - height) / 2) * getScaleDir(height, imageHeight);

  return {
    x: parseFloat(
      (
        (point.x - imageLayer.x - xOffset * imageLayer.scale) /
        (imageLayer.scale * imageWidth)
      ).toFixed(NORMALIZED_VALUES_FIXED)
    ),
    y: parseFloat(
      (
        (point.y - imageLayer.y - yOffset * imageLayer.scale) /
        (imageLayer.scale * imageHeight)
      ).toFixed(NORMALIZED_VALUES_FIXED)
    ),
  };
}

type denormalizePointType = {
  point: Point;
  width: number;
  height: number;
  imageLayer: any;
  imageWidth: number;
  imageHeight: number;
};

export function denormalizePoint({
  point,
  width,
  height,
  imageLayer,
  imageWidth,
  imageHeight,
}: denormalizePointType): Point {
  const xOffset = ((imageWidth - width) / 2) * getScaleDir(width, imageWidth);
  const yOffset = ((imageHeight - height) / 2) * getScaleDir(height, imageHeight);

  return {
    x: parseFloat(
      (
        point.x * imageLayer.scale * imageWidth +
        imageLayer.x +
        xOffset * imageLayer.scale
      ).toFixed(NORMALIZED_VALUES_FIXED)
    ),
    y: parseFloat(
      (
        point.y * imageLayer.scale * imageHeight +
        imageLayer.y +
        yOffset * imageLayer.scale
      ).toFixed(NORMALIZED_VALUES_FIXED)
    ),
  };
}

type useNormalizationToolsType = {
  width: number;
  height: number;
  imageLayer: any;
  imageWidth: number;
  imageHeight: number;
};

export function useNormalizationTools(context: useNormalizationToolsType) {
  const contextedNormalization = useCallback(
    (point: Point) => normalizePoint({...context, point}),
    [context]
  );
  const contextedDenormalization = useCallback(
    (point: Point) => denormalizePoint({...context, point}),
    [context]
  );

  return {
    normalizePoint: contextedNormalization,
    denormalizePoint: contextedDenormalization,
  };
}
